import PropTypes from "prop-types";
import { FullPageLoading } from "../../FullPageLoading";

const CrudFormPage = ({ isLoadingSubmit, children }) => (
  <>
    {
      isLoadingSubmit ? (
        <FullPageLoading />
      ) : (
        children
      )
    }
  </>
)

CrudFormPage.propTypes = {
  isLoadingSubmit: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default CrudFormPage;